import {
  GET_FACTURES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  factures: [],
  error: {},
};

const Facture = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_FACTURES:
          return {
            ...state,
            factures: action.payload.data,
            isFactureCreated: false,
            isFactureSuccess: true,
          };

        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_FACTURES:
          return {
            ...state,
            error: action.payload.error,
            isFactureCreated: false,
            isFactureSuccess: false,
          };

        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Facture;
